function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const COLUMN_1 = {
  links: [{
    intlLabelKey: 'companyAbout',
    intlDescriptionKey: 'companyAboutDescription',
    intlLinkTitleKey: 'aboutLinkTitle',
    url: 'https://www.coinbase.com/about',
    iconType: 'icon',
    iconName: 'info'
  }, {
    intlLabelKey: 'careers',
    intlDescriptionKey: 'careersDescription',
    intlLinkTitleKey: 'careersLinkTitle',
    url: 'https://www.coinbase.com/careers',
    iconType: 'icon',
    iconName: 'briefcase'
  }, {
    intlLabelKey: 'affiliates',
    intlDescriptionKey: 'affiliatesDescription',
    intlLinkTitleKey: 'affiliatesLinkTitle',
    url: 'https://www.coinbase.com/affiliates',
    iconType: 'icon',
    iconName: 'affiliates'
  }, {
    intlLabelKey: 'support',
    intlDescriptionKey: 'supportDescription',
    intlLinkTitleKey: 'supportLinkTitle',
    url: 'https://help.coinbase.com',
    iconType: 'icon',
    iconName: 'chatBubble'
  }, {
    intlLabelKey: 'blog',
    intlDescriptionKey: 'blogDescription',
    intlLinkTitleKey: 'blogLinkTitle',
    url: 'https://www.coinbase.com/blog',
    iconType: 'icon',
    iconName: 'blog'
  }, {
    intlLabelKey: 'security',
    intlDescriptionKey: 'securityDescription',
    intlLinkTitleKey: 'securityLinkTitle',
    url: 'https://www.coinbase.com/security',
    iconType: 'icon',
    iconName: 'shield'
  }]
};
const PRODUCT_LIST = [COLUMN_1];

// Hide affiliates link for UK FinProm compliance
const EXCLUDED_UK_LABELS = new Set(['affiliates']);
const PRODUCT_LIST_UK = PRODUCT_LIST.map(column => _objectSpread(_objectSpread({}, column), {}, {
  links: column.links.filter(link => !EXCLUDED_UK_LABELS.has(link.intlLabelKey))
}));
export { COLUMN_1, PRODUCT_LIST, PRODUCT_LIST_UK };
//# sourceMappingURL=constants.js.map
